/**
 * Login View [caliente]
 */

define(function(require) {
    'use strict';

    const _ = require('underscore');
    const LoginView = require('portlets/login/login.view');
    const Form = require('class/form.class');
    const core = require('core');
    const url = require('util/url.util');
    const user = require('user');
    const $ = require('j');
    const device = require('util/device.util');
    const storage = require('util/storage.util');
    const config = require('config');
    const historyUtil = require('util/history.util');
    const { prevPath } = historyUtil?.state?.state || {};

    return LoginView.extend({

        formTemplate: 'login.form',

        mainTemplate: 'login.view',

        webContentIDs: {
            inBox: config.get('loginPopupWebContentInBox'),
            outBox: config.get('loginPopupWebContentOutBox'),
            outBoxLP: config.get('loginPopupWebContentOutBoxLP')
        },

        initialize: function initialize(options) {
            this.options = _.extend({}, this.defaults.options, options);

            this.initRecaptcha({
                selector: '.fn-login-recaptcha',
                operation: 'login'
            });

            const afterLoginUrl = url.getLocationParameterByName('afterLoginUrl');

            if (afterLoginUrl) {
                const cleanURL = new URL(window.location.href);

                cleanURL.searchParams.delete('afterLoginUrl');

                storage.session.setItem('afterLoginUrl', afterLoginUrl);
                window.Playtech.API.common.replace(window.location.pathname, undefined, {
                    removeParams: ['afterLoginUrl']
                });
            }

            /* TotalCasino changes */
            const loginPage = config.get('loginPage')?.trim();
            const hasLoginPage = Boolean(loginPage && loginPage.length > 0);
            const loginPageInPopup = hasLoginPage && Playtech.Variables?.pageInPopupUrls?.includes(loginPage);

            if (hasLoginPage && !loginPageInPopup && device.formFactor !== 'desktop') {
                this.setBackButtonBehavior();
            }
            /* TotalCasino changes */
        },

        /**
         * Navigate to login action url after login
         */
        afterLoginAction: function() {
            const params = url.getURLParams();
            const loginAction = url.getLocationParameterByName('login_action');
            const backPageUrlStored = storage.session.getItem('backPageUrl'); /* TotalCasino changes */

            let path = params[loginAction] || loginAction;

            // MCBB-119
            path = path && path.replace(/preferedmode=offline/, 'preferedmode=real')
                .replace(/real=0/, 'real=1');

            /* TotalCasino changes */
            if(loginAction) {
                window.Playtech.API.common.replace(backPageUrlStored || url.pathname, undefined, {
                    removeParams: ['login_action', loginAction]
                });
            }
            /* TotalCasino changes */

            if (!path || !window.Playtech.API.common.isAllowedToRedirect(path)) {
                return;
            }

            // continue register for fast registered players
            if (user.isFastRegistered()) {
                user.continueRegistration(false, { href: path });
            } else {
                window.Playtech.API.common.navigate(path);
            }
        },

        setBackButtonBehavior: function setBackButtonBehavior() {
            history.pushState({
                prevPath: prevPath,
                showBack: true
            }, 'login');
            core.trigger('backButton:show');
        },

        subscribe: function() {
            LoginView.prototype.subscribe.apply(this, arguments);

            if (device.browserName === 'safari') {
                window.addEventListener('pageshow', this.onPageShow); // handle a case when page is loaded from a cache
            }

            this.listenTo(core, 'login:messages', Form.prototype.showErrorMessage);
        },

        render: function() {
            const forgotUserNameLink = config.get('dynamicTags.DTAG_FORGOT_USERNAME_PAGE');
            const forgotPasswordLink = config.get('dynamicTags.DTAG_FORGOT_PASS_PAGE');
            let userCookie = $.cookie('u_c');
            let userData = {};
            let password = '';

            if (userCookie && (userData = JSON.parse(decodeURIComponent(decodeURIComponent(userCookie))))) {
                password = userData.up === undefined || userData.up === ''
                    ? ''
                    : String.fromCharCode.apply(this, userData.up.split('&').map(Number));
            }

            this.$el.html(this.tmpl(this.mainTemplate));

            this.$el.find('.fn-form-container').append(this.tmpl(this.formTemplate, {
                password: password,
                isRememberMeByPas: this.isRememberMeByPas(),
                forgotUserNameLink: forgotUserNameLink,
                forgotPasswordLink: forgotPasswordLink
            }));

            this.form = new Form(this.$('.fn-login'), this.getTmplData());

            this.loadAndInsertWebContent(this.webContentIDs.inBox, '.fn-login__webcontent-in-box');
            this.loadAndInsertWebContent(this.webContentIDs.outBox, '.fn-login__webcontent-out-box');

            return this;
        },

        extendOptions: function(options) {
            if (options) {
                _.extend(this.options, options);
            }
        },

        loadAndInsertWebContent: function(webContent, selectorOfContainer) {
            this.loadContent(webContent).done(function(response) {
                if (response) {
                    this.$el.find(selectorOfContainer).html(response);
                }
            }.bind(this));
        },

        checkIfShouldAcceptTC: function(response) {
            var sessionValidation = response.data.sessionValidationData;
            var shouldAcceptTC = sessionValidation
                && sessionValidation.SessionValidationByTCVersionData
                && user.get('relogin');

            if (shouldAcceptTC) {
                core.once('tc:accept', this.successLogin.bind(this));
            }
        },

        errorLogin: function(response) {
            if (device.formFactor !== 'desktop') {
                var data = response.data;

                if (data.errorCode === 301) {
                    this.showSubmitRecaptcha({
                        onError: err => this.form.showErrorMessage(err)
                    });

                    return;
                }

                if (data.errorCode === 0) {
                    return;
                }

                var spareMessage = data.actions
                    ? data.actions.PlayerActionShowMessage[0].message
                    : data.errorMessage || data.playerMessage;

                core.trigger('login:messages', {
                    translation: 'playtech.mobile.system.login.error.' + data.errorCode,
                    content: spareMessage
                });

            } else {
                LoginView.prototype.errorLogin.apply(this, arguments);

                this.checkIfShouldAcceptTC(response);
            }
        },

        onPageShow: function(event) {
            if (event.persisted) {
                window.location.reload();
            }
        },

        close: function() {
            LoginView.prototype.close.apply(this, arguments);

            window.removeEventListener('pageshow', this.onPageShow);
        }
    });
});
